// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 362) return "static/chunks/b6715477.ddd413a80ecde33b.js";
	if (chunkId === 453) return "static/chunks/453.c23ba2b16c2094c9.js";
	if (chunkId === 910) return "static/chunks/910.d6096feac894af5e.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 978 ? "fbc1ab8d" : chunkId) + "-" + {"322":"c451f6d1f317e68b","615":"2ad663077ee4bb06","688":"82c882c08a1530e5","978":"f82da08353c9e5ab"}[chunkId] + ".js";
};